import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { IBranchMastDropdown, ICompanyMastDropdown, ISkillCategoriesDropdown, ITeamsDropdown, IUsersDropdown } from "../../../models/IDropdown";
import { ILogin } from "../../../models/Login";
import { Fetch } from "../../../shared/Fetch";
import { JVDropdown } from "../../../shared/JVDropdown";

export interface IBidTeamSkillFilter {
  // fromDate?: Date | null,
  // toDate?: Date | null,
  company?: number | null;
  branch?: number | null;
  category?: number | null;
  team?: number | null;
}

export const BidTeamEmptySkillFilter: IBidTeamSkillFilter = {
  company: null,
  branch: null,
  category: null,
  team: null,
};

interface IFilterProps {
  skillFilter: IBidTeamSkillFilter;
  setSkillFilter: (skillFilter: IBidTeamSkillFilter) => void;
}

const schema = yup.object({
  // fromDate: yup.date().nullable(),
  // toDate: yup.date().nullable(),
  company: yup.number().nullable(),
  branch: yup.number().nullable(),
  req_Category: yup.number().nullable(),
  team: yup.number().nullable(),
});

export const Filter = (props: IFilterProps) => {
  const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
  const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
  // const [team, setTeam] = useState<Array<ITeamsDropdown>>();
  const [teams, setTeams] = useState<Array<ITeamsDropdown>>();

  const { control, handleSubmit, reset, watch } = useForm<IBidTeamSkillFilter>({
    defaultValues: props.skillFilter,
    resolver: yupResolver(schema),
    shouldFocusError: false,
  });

  const _roles: Array<number> = [];
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });

  const loadSkillCategories = async () => {
    const response = await Fetch("Dropdown/skillsCategories", "GET", null, null, null);
    if (response) {
      const data: Array<ISkillCategoriesDropdown> = await response.json();
      const emptyData = {
        req_CategoryID: 0,
        req_CategoryName: "-- SELECT --",
      };
      data.unshift(emptyData);
    }
  };

  const loadBranches = async (company?: number | null | undefined) => {
    let queryParam = company ? `company_id=${company}` : null;
    let endPoint = loginObj.id === 1346 ? "allBranches" : "reqBranchList";

    const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, queryParam, null);
    if (response) {
      const data: Array<IBranchMastDropdown> = await response.json();
      const emptyData = {
        branch_ID: 0,
        branchName: "-- SELECT --",
        company_ID: 0,
      };
      data.unshift(emptyData);
      setBranches(data);
    }
  };

  const loadCompanies = async () => {
    let endPoint = loginObj.id === 1346 ? "company" : "reqCompanyList";

    const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, null, null);
    if (response) {
      const data: Array<ICompanyMastDropdown> = await response.json();
      const emptyData = {
        company_ID: 0,
        company_Name: "-- SELECT --",
      };
      data.unshift(emptyData);
      setCompanies(data);
    }
  };

  const loadTeam = async (branch: number | null | undefined, company: number | null | undefined, type?: string) => {
    let queryParameter = null;
    if (branch !== 0 && branch != null) {
      queryParameter = `branch_ID=${branch}`;
    } else if (company !== 0 && company != null) {
      queryParameter = `company_ID=${company}`;
    }

    if (type && type != "" && type != "-- SELECT --") {
      if (type === "sales") queryParameter = "user_Type=sales&" + queryParameter;
      if (type === "recruiter") queryParameter = "user_Type=recruiter&" + queryParameter;
    }

    const response = await Fetch("Dropdown/filterTeamsList", "GET", null, queryParameter, null);
    if (response) {
      const data: Array<ITeamsDropdown> = await response.json();
      const emptyData = {
        team_ID: 0,
        team_Name: "-- SELECT --",
      };
      data.unshift(emptyData);
    
    }
  };

  const loadSm = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
    let queryParameter = null;

    if (team !== 0 && team != null) {
      queryParameter = `team_ID=${team}`;
    } else if (branch !== 0 && branch != null) {
      queryParameter = `branch_ID=${branch}`;
    } else if (company !== 0 && company != null) {
      queryParameter = `company_ID=${company}`;
    }

    const response = await Fetch("RPF_Bid_Team_Management/getBidTeams", "GET", null, queryParameter, null);

    if (response) {
      const data: Array<ITeamsDropdown> = await response.json();

      data.unshift({
        team_ID: 0,
        team_Name: "-- SELECT --",
      });

      setTeams(data);
    }
  };
  const searchToDB = async (body: IBidTeamSkillFilter) => {
    let filterData: any = body;
    let emptyFilter: any = BidTeamEmptySkillFilter;
    for (let key in filterData) {
      if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
        filterData[key] = emptyFilter[key];
      }
    }
    body = filterData;
    props.setSkillFilter(body);
  };

  const onSubmit = (data: IBidTeamSkillFilter) => {
    searchToDB(data);
  };

  const Clear = () => {
    reset(BidTeamEmptySkillFilter);
    props.setSkillFilter(BidTeamEmptySkillFilter);
    loadSm(0, 0, 0);
    loadTeam(0, 0, "");
    loadBranches();
    loadCompanies();
  };
  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name === "company") {
        if (value.company !== 0 && value.company != null) {
          loadTeam(0, value.company);
          loadSm(0, value.company, 0);
          loadBranches(value.company);
        } else {
          if (value.company === 0 && value.company != null) {
            loadBranches();
            loadTeam(control._formValues.branch, value.company);
            loadSm(control._formValues.branch, value.company, control._formValues.team);
          }
        }
      }

      if (name === "branch") {
        if (value.branch !== 0 && value.branch != null) {
          loadTeam(value.branch, 0);
          loadSm(value.branch, 0, 0);
        } else {
          if (value.branch === 0 && value.branch != null) {
            loadTeam(value.branch, control._formValues.company);
            loadSm(value.branch, control._formValues.company, control._formValues.team);
          }
        }
      }

      if (name === "team") {
        if (value.team !== 0 && value.team != null) {
          loadSm(0, 0, value.team);
        } else {
          if (value.team === 0 && value.team != null) {
            loadSm(control._formValues.branch, control._formValues.company, value.team);
          }
        }
      }
    });

    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    loadTeam(0, 0);
    loadSm(0, 0, 0);
    loadCompanies();
    loadBranches();
    loadSkillCategories();
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
      <JVDropdown column={6} label="Company" control={control} name="company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
      <JVDropdown column={6} label="Branch" control={control} name="branch" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />
      <JVDropdown column={6} label="Team" control={control} name="team" options={teams} optionLabel="team_Name" optionValue="team_ID" />
      {/* <JVDropdown column={6} label="Team Manager" control={control} name="teamManager" options={teams} optionLabel="team_Name" optionValue="team_ID" placeholder="Select Team" /> */}

      <div style={{ margin: "10px 0", width: "100%" }}></div>
      <div className="col-12 md:col-12" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "10px", marginTop: "10px" }}>
        <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
        <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={Clear} type="button"></Button>
      </div>
    </form>
  );
};
